import { FC } from 'react';
import { BrandToggle } from '@features/theme/components/BrandToggle';
import { DarkModeToggle } from '@features/theme/components/DarkModeToggle';

export const ShowcaseToolbar: FC = () => {
  return (
    <div 
      className='shadow-sm px-4 d-flex justify-content-end align-items-center gap-3 w-100'
      style={{ 
        position: 'sticky', 
        top: '64px', // Assuming main header height is roughly 64px
        zIndex: 1020,
        height: '60px',
        backgroundColor: 'var(--theme-TextWhite)',
        borderBottom: '1px solid var(--theme-NeutralsLight)', 
      }} 
    >
      <div className='d-flex align-items-center gap-3'>
        <span className='small font-weight-bold text-uppercase' style={{ color: 'var(--theme-TextMedium)' }}>Theme Controls:</span>
        <DarkModeToggle />
        <BrandToggle />
      </div>
    </div>
  );
};
